window.stimulusApp.register(
  "auth-tracking",
  class extends Stimulus.Controller {
    static values = {
      event: String,
      submitEvent: String,
      ptpSource: String,
      fromInline: String,
      emailHash: String,
      hasError: Boolean,
    }

    #submitted = false

    connect() {
      if (this.hasErrorValue) {
        Activity.capture("auth pincode failed", this.#properties())
      } else {
        Activity.capture(this.eventValue, this.#properties())
      }
    }

    trackSubmit() {
      if (this.#submitted) return
      this.#submitted = true
      Activity.capture(this.submitEventValue, this.#properties())
    }

    trackResend() {
      Activity.capture("auth pincode resend requested", this.#properties())
    }

    trackSelect(event) {
      Activity.capture("auth method selected", {
        method: event.params.method,
        ...this.#properties(),
      })
    }

    #properties() {
      let props = {}
      if (this.ptpSourceValue) props.ptp_source = this.ptpSourceValue
      if (this.fromInlineValue) props.from_inline = this.fromInlineValue
      if (this.emailHashValue) props.email_md5 = this.emailHashValue
      return props
    }
  },
)
